<script lang="ts">
import type { SetupContext } from 'vue';
import { defineComponent } from 'vue';
import type { HekateDisplayField } from '@onshape/www-inertia';
import { Trans } from '@onshape/www-inertia';
import CoordinatorProvider from '../coordinator/CoordinatorProvider';
import FieldErrorMessage from './FieldErrorMessage.vue';

export default defineComponent({
  components: {
    FieldErrorMessage,
  },
  props: {
    field: {
      required: true,
      type: Object as unknown as () => HekateDisplayField,
    },
    modelValue: {
      required: true,
      type: String,
    },
  },
  setup(props, context: SetupContext) {
    const {
      isRecaptcha,
      recaptchaElement,
      isShowNoRecaptchaError,
      isRecaptchaLoading,
      isRecaptchaV3,
      isRecaptchaV2,
    } = CoordinatorProvider.get().recaptchaField({
      context,
    });

    return {
      recaptchaElement,
      isRecaptcha,
      isShowNoRecaptchaError,
      isRecaptchaLoading,
      isRecaptchaV3,
      isRecaptchaV2,
      couldNotLoadRecaptcha: Trans.byKey('couldNotLoadRecaptcha'),
    };
  },
});
</script>

<template>
  <div class="field-submit field-recaptcha">
    <field-error-message
      v-if="isShowNoRecaptchaError"
      class="top-message"
      :messages="[
        {
          message: couldNotLoadRecaptcha,
        },
      ]"
    />
    <field-error-message
      class="top-message"
      :messages="field.errorMessages"
    />
    <div class="recaptcha-box">
      <span v-if="!isShowNoRecaptchaError && isRecaptchaLoading"> Loading reCAPTCHA ... </span>
      <div
        v-if="isRecaptchaV2"
        id="hk-recaptcha-element-v2"
        ref="recaptchaElement"
      ></div>
      <div
        v-if="isRecaptchaV3"
        id="hk-recaptcha-element-v3"
        ref="recaptchaElement"
      ></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.field-recaptcha {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 12px;
}
</style>
